import { BaseModel } from "modules/core";

export class UserDetailsModel extends BaseModel {
    name!: string;
    emailAddress!: string;
    mobileNumber!: string;
    userName!: string;
    active!: boolean;
    roleId!: number;
    password!: string;
    remark!: string;
    multiDeviceLoginEnabled!: boolean;

    static setUserData(data: UserDetailsModel): UserDetailsModel {
        const model = new UserDetailsModel();
        model.id = data.id ?? 0;
        model.name = data.name?.trim() || "";
        model.emailAddress = data.emailAddress?.trim() || "";
        model.mobileNumber = data.mobileNumber?.trim() || "";
        model.userName = data.userName?.trim() || "";
        model.active = !!data.active;
        model.roleId = Number(data.roleId || 0);
        model.password = data.password?.trim() || "";
        model.remark = data.remark?.trim() || "";
        model.multiDeviceLoginEnabled = !!data.multiDeviceLoginEnabled;
        return model;
    }
}
